import type { DecisionChoose, TreeOption } from '@nsb/core';
import { useId } from 'react';
import { Choices } from './ui.tsx';

/**
 * A decision's options to choose from, deciding it (design study 22; Jason, 2026-10-07: "either select one of many or
 * many of many"): one of them as `Choices` rows, or any number of them as the same rows with a box to tick each. Used
 * wherever a decision is decided: the client's Waiting on you and Decisions page, and the step's panel on NSB's side.
 */
export function DecisionChoice({
  legend,
  options,
  choose,
  value,
  onChange,
  disabled = false,
}: {
  legend: string;
  options: readonly TreeOption[];
  choose: DecisionChoose;
  value: readonly string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
}) {
  const name = useId();
  if (choose === 'one') {
    return <Choices legend={legend} value={value[0] ?? ''} options={options.map((o) => ({ value: o.id, label: o.text }))} onPick={(id) => onChange([id])} disabled={disabled} />;
  }
  return (
    <fieldset className="mb-5">
      <legend className="label mb-1 block">{legend}</legend>
      <div className="border-y border-rule">
        {options.map((o) => (
          <label key={o.id} className="flex min-h-11 cursor-pointer items-baseline gap-3 border-b border-rule py-3 last:border-b-0">
            <input
              type="checkbox"
              name={name}
              className="relative top-0.5 size-4 shrink-0 accent-moss"
              checked={value.includes(o.id)}
              disabled={disabled}
              onChange={(e) => onChange(e.target.checked ? [...value, o.id] : value.filter((x) => x !== o.id))}
            />
            <span>{o.text}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
